import type { ChipProps } from '@citibox-panel/ui';
import { ANONYMIZED_STATUS } from '../../../lib/isAnonymized';

// Fail-open mapping of the open «Usuario» status string to a chip colour: known
// states get a semantic colour, anything else degrades to neutral so a new backend
// state never breaks the ficha. The chip still shows the raw status as its label.
export function statusColor(status: string): NonNullable<ChipProps['color']> {
  switch (status) {
    case 'activo':
      return 'success';
    case 'bloqueado':
      return 'error';
    // Explicit rather than left to fall through the default below, so the neutral
    // colour is a stated intent, not an inherited side effect. ANONYMIZED_STATUS
    // (isAnonymized.ts) is the single edit point for the wire literal.
    case ANONYMIZED_STATUS:
      return 'default';
    default:
      return 'default';
  }
}
